<template>
  <div>
    <pre class="container" v-html="htmlString"></pre>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>

<script>
import Loading from "@components/moblie/Loading";
export default {
  name: "unionpay",
  components: {
    Loading
  },
  data() {
    return {
      htmlString: "",
      loaded: true,
      loading: true
    };
  },
  methods: {},
  created() {},
  mounted() {
    console.log(this.$route.query.jsconfig);
    // this.htmlString = this.$route.query.jsconfig;
    this.htmlString = this.$route.params.jsconfig;
    // this.htmlString = this.htmlString.replace(/<!--/g, "");
    // this.htmlString = this.htmlString.replace(/-->/g, "");
    // this.htmlString = this.htmlString.replace(
    //   `<input type="submit" type="hidden">`,
    //   `<input type="submit" class="unionpay_submit" style="margin-left:36%;color:white;padding:5px;background-color:rgb(64,105,255);border-radius:4px"/>`
    // );
    console.log(this.htmlString);
    setTimeout(() => {
      let form = document.getElementById("pay_form");
      form.submit();
    }, 800);
  },

  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang="scss" scoped>
.unionpay_submit {
  margin: auto;
}
input {
  margin: auto;
}
</style>
